import { useFormikContext } from 'formik';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { Text } from '../../../../cdl/Text/Text';
import { OfferModel } from '../../../../offer/model/OfferModel';
import {
    calculateItemTotal,
    calculatePpl,
    calculateTotal,
    calculateVolume,
    calculateVolumeWithPrices,
} from '../../../helpers/calculate.utilities';
import { formatLubesPrice } from '../../../helpers/formatLubesPrice.helper';
import { formatLubesTotalPrice } from '../../../helpers/formatLubesTotal.helper';
import { formatNumber } from '../../../helpers/formatNumber.helper';
import { translate } from '../../../helpers/translate.helper';
import { Box } from '../../../ui/Box';
import { get } from '../../../ui/get';
import { useLubesProductTableConfig } from '../hooks/useLubesProductTableConfig';

import { TotalRowTd } from './TotalRowTd';

interface TotalValueWrapperProps {
    children: ReactNode;
}

const TotalValueWrapper = ({ children }: TotalValueWrapperProps) => {
    return (
        <Box display="flex" justifyContent="flex-end">
            <Text variant="body">{children}</Text>
        </Box>
    );
};

const CustomTr = styled.tr`
    background-color: ${get('colors.background.subtle')};

    border-bottom: 1px solid ${get('colors.border.subtle')} !important;
    border-right: 1px solid ${get('colors.border.subtle')} !important;
    border-left: 1px solid ${get('colors.border.subtle')} !important;
`;

export const TotalRow = () => {
    const { values } = useFormikContext<OfferModel>();
    const { editPrices } = useLubesProductTableConfig();

    const totalVolume = calculateVolume(values.items);
    const allTotal = calculateTotal(values.items, values.surcharges, values.samplekits);

    const pricePerLiter = calculatePpl(calculateItemTotal(values.items), calculateVolumeWithPrices(values.items));
    return (
        <CustomTr>
            <TotalRowTd colSpan={5}>
                <Text variant="body">{translate('global.total')}</Text>
            </TotalRowTd>

            <TotalRowTd>
                <TotalValueWrapper>
                    {formatNumber({ number: totalVolume, minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                </TotalValueWrapper>
            </TotalRowTd>

            <TotalRowTd />

            <TotalRowTd>
                <Box display="flex" justifyContent={editPrices ? 'flex-start' : 'flex-end'}>
                    <Text variant="body">
                        {pricePerLiter.value
                            ? formatLubesPrice({
                                  value: pricePerLiter.value,
                                  currency: pricePerLiter.currency || 'USD',
                              })
                            : '-'}
                    </Text>
                </Box>
            </TotalRowTd>

            <TotalRowTd>
                <TotalValueWrapper>
                    {allTotal.value
                        ? formatLubesTotalPrice({
                              value: allTotal.value,
                              currency: allTotal.currency || 'USD',
                          })
                        : '-'}
                </TotalValueWrapper>
            </TotalRowTd>

            <TotalRowTd>{null}</TotalRowTd>
        </CustomTr>
    );
};
